import { createAction } from '@reduxjs/toolkit';

import type { UnlimitedDocumentsEntryPoint, UnlimitedDocumentsTariffType } from './unlimitedDocuments.const';

export interface BuyUnlimitedDocumentsTariffType {
    onShow?: () => void;
    onClick?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    stage: 'start' | 'thanks';
    type: UnlimitedDocumentsTariffType;
    offer_source: UnlimitedDocumentsEntryPoint;
}

const buyUnlimitedDocumentsTariff = createAction<BuyUnlimitedDocumentsTariffType>('unlimitedDocuments/buyUnlimitedDocuments');

export const UnlimitedDocumentsActions = {
    buyUnlimitedDocumentsTariff,
} as const;
